
import { Product, Vendor, Driver, RegionalId, Client } from './types';

export const APP_NAME = "E-Ambulante";
export const APP_VERSION = '1.2.5';

export const CURRENCY = "R$";
export const LOCALE = 'pt-BR';
export const MONTHLY_FEE = 29.90;
export const PLATFORM_FEE_PERCENTAGE = 0.10;
/** @deprecated use PRODUCT_PLACEHOLDER — mantido como alias do SVG neutro */
export { PRODUCT_PLACEHOLDER as DEFAULT_PRODUCT_IMAGE } from './src/constants/productImage';

// ============================================
// SISTEMA DE REGIONAIS DE FORTALEZA
// FONTE ï¿½NICA DE VERDADE - usar sempre esta constante
// ============================================
export const REGIONAIS_FORTALEZA: readonly RegionalId[] = [
  'Regional 1',
  'Regional 2',
  'Regional 3',
  'Regional 4',
  'Regional 5',
  'Regional 6',
  'Regional 7',
  'Regional 8',
  'Regional 9',
  'Regional 10',
  'Regional 11',
  'Regional 12',
] as const;

// Mapeamento de bairros por regional (expandir conforme necessï¿½rio)
export const BAIRROS_POR_REGIONAL: Record<RegionalId, string[]> = {
  'Regional 1': ['Centro', 'Aldeota', 'Meireles', 'Varjota', 'Mucuripe'],
  'Regional 2': ['Messejana', 'Curiï¿½', 'Ancuri', 'Guajeru', 'Coaï¿½u'],
  'Regional 3': ['Antï¿½nio Bezerra', 'Padre Andrade', 'Quintino Cunha', 'Presidente Kennedy'],
  'Regional 4': ['Mondubim', 'Conjunto Cearï¿½', 'Jardim Cearense', 'Planalto Ayrton Senna'],
  'Regional 5': ['Barra do Cearï¿½', 'Cristo Redentor', 'Pirambu', 'Vila Velha', 'Carlito Pamplona'],
  'Regional 6': ['Edson Queiroz', 'Cidade dos Funcionï¿½rios', 'Sapiranga', 'Manoel Dias Branco'],
  'Regional 7': ['Passarï¿½', 'Barroso', 'Paupina', 'Pedras', 'Parque Dois Irmï¿½os'],
  'Regional 8': ['Parangaba', 'Maraponga', 'Vila Peri', 'Itaperi', 'Serrinha'],
  'Regional 9': ['Bom Jardim', 'Siqueira', 'Canindezinho', 'Granja Lisboa', 'Granja Portugal'],
  'Regional 10': ['Cais do Porto', 'Vicente Pinzon', 'Praia do Futuro', 'Serviluz'],
  'Regional 11': ['Jangurussu', 'Ancuri', 'Pedras', 'Sabiaguaba'],
  'Regional 12': ['Barroso', 'Dendï¿½', 'Parque Santa Maria', 'Parreï¿½o', 'Pedras'],
};

// Limites Tï¿½cnicos
export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const FREE_DELIVERY_THRESHOLD = 50; 
export const BASE_DELIVERY_FEE = 6;

// ============================================
// ?? CONFIGURAï¿½ï¿½O DE FRETE POR DISTï¿½NCIA
// Regra: Atï¿½ 2km = R$ 6,00 fixo
//        Cada km adicional = R$ 3,00
// ============================================
export const DELIVERY_CONFIG = {
  BASE_DISTANCE_KM: 2,           // Distância base em km (taxa fixa)
  BASE_FEE: 6.00,                // Taxa mínima (até 2km)
  ADDITIONAL_FEE_PER_KM: 2.00,   // Taxa adicional por km extra
  MAX_DISTANCE_KM: 15,           // Distância máxima de entrega
  MIN_FEE: 6.00,                 // Taxa mínima
  MAX_FEE: 32.00,                // Taxa máxima (15km)
} as const;

// Tabela de frete atualizada (28/04/2026):
// 1.0 km  → R$ 6,00  (mínimo)
// 2.0 km  → R$ 6,00  (mínimo)
// 3.0 km  → R$ 6,00 + (1 × R$ 2,00) = R$ 8,00
// 5.0 km  → R$ 6,00 + (3 × R$ 2,00) = R$ 12,00
// 8.0 km  → R$ 6,00 + (6 × R$ 2,00) = R$ 18,00
// 10.0 km → R$ 6,00 + (8 × R$ 2,00) = R$ 22,00
// 15.0 km → R$ 6,00 + (13 × R$ 2,00) = R$ 32,00

export const DEBOUNCE_STORAGE_MS = 1000;
export const DEBOUNCE_SEARCH_MS = 300;

// Cores Oficiais Premium
export const THEME_COLORS = {
  primary: '#00C853',
  primaryDark: '#009624',
  secondary: '#FF6D00',
  accent: '#1C3AA9',
} as const;

export const BRAND_ASSETS = {
  MAIN_LOGO: "https://images.unsplash.com/photo-1582266255765-fa5cf1a1d501?auto=format&fit=crop&q=80&w=300", 
  ICON_LOGO: "https://images.unsplash.com/photo-1582266255765-fa5cf1a1d501?auto=format&fit=crop&q=80&w=100",
  HERO_BANNER: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&q=80&w=1200",
  DEFAULT_VENDOR_BANNER: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&q=80&w=1200"
};

export const FOOD_IMAGES = {
  TAPIOCA_QUEIJO: "https://images.unsplash.com/photo-1626202157773-199f7f4f603c?auto=format&fit=crop&q=80&w=400",
  TAPIOCA_CARNE: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?auto=format&fit=crop&q=80&w=400",
  AGUA_COCO: "https://images.unsplash.com/photo-1543158071-94754a65728f?auto=format&fit=crop&q=80&w=400",
  SUCO_CAJA: "https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?auto=format&fit=crop&q=80&w=400",
  PASTEL_CAMARAO: "https://images.unsplash.com/photo-1595295333158-4742f28fbd85?auto=format&fit=crop&q=80&w=400"
};

// ============================================
// DADOS DE TESTE - AMBIENTE COMPLETO
// Para testar: compra, pagamento, entrega, documentos, chat, regionais
// ============================================

export const INITIAL_VENDORS: Vendor[] = [
  // VENDEDOR REGULAMENTADO - REGIONAL 1
  {
    id: 'vendor_r1_01',
    name: 'Josï¿½ Tapioqueiro',
    ownerName: 'Josï¿½ da Silva',
    storeName: 'Tapiocas do Zï¿½',
    email: 'vendedor.r1@test.com',
    phone: '85988001001',
    image: 'https://images.unsplash.com/photo-1566121430645-e459ecd33790?auto=format&fit=crop&q=80&w=300',
    location: { lat: -3.7327, lng: -38.4692 },
    vendorStatus: 'REGULATED',
    regionalId: 'Regional 1',
    permitNumber: 'LIC-2026-R1-001',
    cpfCnpj: '12345678900',
    regulatedAt: '2026-01-15T10:00:00Z',
    approvedBy: 'fiscal_r1_01',
    subscriptionStatus: 'active',
    vendorType: 'GASTRONOMIA'
  },
  
  // VENDEDOR REGULAMENTADO - REGIONAL 2
  {
    id: 'vendor_r2_01',
    name: 'Ana das ï¿½guas',
    ownerName: 'Ana Maria Costa',
    storeName: 'ï¿½gua de Coco da Ana',
    email: 'vendedor.r2@test.com',
    phone: '85988002002',
    image: 'https://images.unsplash.com/photo-1525904097878-94fb15835963?auto=format&fit=crop&q=80&w=300',
    location: { lat: -3.7310, lng: -38.4680 },
    vendorStatus: 'REGULATED',
    regionalId: 'Regional 2',
    permitNumber: 'LIC-2026-R2-001',
    cpfCnpj: '98765432100',
    regulatedAt: '2026-01-18T14:30:00Z',
    approvedBy: 'fiscal_r2_01',
    subscriptionStatus: 'active',
    vendorType: 'BEBIDAS'
  },

  // VENDEDOR PENDENTE APROVAï¿½ï¿½O - REGIONAL 1
  {
    id: 'vendor_pending_01',
    name: 'Pedro Aguardando Aprovaï¿½ï¿½o',
    ownerName: 'Pedro Henrique',
    storeName: 'Pastï¿½is do Pedro',
    email: 'vendedor.pendente@test.com',
    phone: '85988003003',
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&q=80&w=300',
    location: { lat: -3.7335, lng: -38.4675 },
    vendorStatus: 'PENDING_VERIFICATION',
    regionalId: 'Regional 1',
    permitNumber: 'PEND-2026-001',
    cpfCnpj: '45678912300',
    subscriptionStatus: 'active',
    vendorType: 'LANCHES'
  },

  // VENDEDOR REGULAMENTADO - REGIONAL 5
  {
    id: 'vendor_r5_01',
    name: 'Maria dos Pastï¿½is',
    ownerName: 'Maria de Fï¿½tima',
    storeName: 'Pastï¿½is da Maria',
    email: 'vendedor.r5@test.com',
    phone: '85988005005',
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&q=80&w=300',
    location: { lat: -3.7280, lng: -38.5100 },
    vendorStatus: 'REGULATED',
    regionalId: 'Regional 5',
    permitNumber: 'LIC-2026-R5-001',
    cpfCnpj: '11223344556',
    regulatedAt: '2026-01-20T09:00:00Z',
    approvedBy: 'fiscal_r5_01',
    subscriptionStatus: 'active',
    vendorType: 'LANCHES'
  },

  // VENDEDOR LIVRE (sem regional - empreendedor autï¿½nomo)
  {
    id: 'vendor_unreg_01',
    name: 'Lucas Vendedor Livre',
    ownerName: 'Lucas Empreendedor',
    storeName: 'Barraca do Lucas',
    email: 'vendedor.livre@test.com',
    phone: '85988004004',
    image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?auto=format&fit=crop&q=80&w=300',
    location: { lat: -3.7320, lng: -38.4700 },
    vendorStatus: 'UNREGULATED',
    subscriptionStatus: 'active',
    vendorType: 'DIVERSOS'
  }
];

export const INITIAL_CLIENTS: Client[] = [
  {
    id: 'client_01',
    name: 'Fernanda Costa',
    email: 'cliente1@test.com',
    phone: '85977001001',
    createdAt: '2026-01-20T08:00:00Z',
    addresses: [
      {
        id: 'addr_client01_01',
        street: 'Av. Beira Mar',
        number: '1500',
        neighborhood: 'Meireles',
        city: 'Fortaleza',
        state: 'CE',
        zipCode: '60165-121',
        reference: 'Prï¿½ximo ao Aterro da Praia de Iracema',
        isDefault: true,
      }
    ],
    totalOrders: 0,
    status: 'active',
  },
  {
    id: 'client_02',
    name: 'Roberto Oliveira',
    email: 'cliente2@test.com',
    phone: '85977002002',
    createdAt: '2026-01-21T10:30:00Z',
    addresses: [
      {
        id: 'addr_client02_01',
        street: 'Rua dos Tabajaras',
        number: '234',
        complement: 'Apto 302',
        neighborhood: 'Praia de Iracema',
        city: 'Fortaleza',
        state: 'CE',
        zipCode: '60060-510',
        isDefault: true,
      }
    ],
    totalOrders: 0,
    status: 'active',
  }
];

export const INITIAL_PRODUCTS: Product[] = [
  // PRODUTOS DO JOSï¿½ (TAPIOCAS - REGIONAL 1)
  {
    id: 'prod_jose_01',
    vendorId: 'vendor_r1_01',
    name: { pt: 'Tapioca de Queijo Coalho', en: 'Cheese Tapioca', es: 'Tapioca de Queso' },
    description: { pt: 'Tapioca quentinha com queijo coalho grelhado.', en: 'Hot tapioca with grilled cheese.', es: 'Tapioca caliente con queso asado.' },
    price: 8.00,
    image: FOOD_IMAGES.TAPIOCA_QUEIJO,
    category: 'Tapiocas',
    available: true,
    popular: true
  },
  {
    id: 'prod_jose_02',
    vendorId: 'vendor_r1_01',
    name: { pt: 'Tapioca Carne de Sol', en: 'Sun-Dried Meat Tapioca', es: 'Tapioca Carne Seca' },
    description: { pt: 'Recheada com carne de sol desfiada e queijo.', en: 'Filled with shredded sun-dried meat and cheese.', es: 'Rellena de carne seca deshilachada y queso.' },
    price: 12.00,
    image: FOOD_IMAGES.TAPIOCA_CARNE,
    category: 'Tapiocas',
    available: true
  },

  // PRODUTOS DA ANA (BEBIDAS - REGIONAL 2)
  {
    id: 'prod_ana_01',
    vendorId: 'vendor_r2_01',
    name: { pt: 'ï¿½gua de Coco Gelada', en: 'Chilled Coconut Water', es: 'Agua de Coco Frï¿½a' },
    description: { pt: 'Direto da praia! Natural e refrescante.', en: 'Straight from the beach! Natural and refreshing.', es: 'Directo de la playa! Natural y refrescante.' },
    price: 6.00,
    image: FOOD_IMAGES.AGUA_COCO,
    category: 'Bebidas',
    available: true,
    popular: true
  },
  {
    id: 'prod_ana_02',
    vendorId: 'vendor_r2_01',
    name: { pt: 'Suco de Cajï¿½ Natural', en: 'Fresh Caja Juice', es: 'Jugo de Cajï¿½ Natural' },
    description: { pt: 'Polpa natural sem conservantes. 500ml.', en: 'Natural pulp, no preservatives. 500ml.', es: 'Pulpa natural sin conservantes. 500ml.' },
    price: 10.00,
    image: FOOD_IMAGES.SUCO_CAJA,
    category: 'Bebidas',
    available: true
  },

  // PRODUTOS DO LUCAS (Nï¿½O REGULAMENTADO)
  {
    id: 'prod_lucas_01',
    vendorId: 'vendor_unreg_01',
    name: { pt: 'Milho Cozido', en: 'Boiled Corn', es: 'Maï¿½z Hervido' },
    description: { pt: 'Milho verde cozido com manteiga.', en: 'Boiled corn with butter.', es: 'Maï¿½z hervido con mantequilla.' },
    price: 5.00,
    image: 'https://images.unsplash.com/photo-1551754655-cd27e38d2076?auto=format&fit=crop&q=80&w=400',
    category: 'Lanches',
    available: true
  },

  // PRODUTOS DA MARIA (PASTï¿½IS - REGIONAL 5)
  {
    id: 'prod_maria_01',
    vendorId: 'vendor_r5_01',
    name: { pt: 'Pastel de Camarï¿½o', en: 'Shrimp Pastel', es: 'Pastel de Camarï¿½n' },
    description: { pt: 'Pastel crocante recheado com camarï¿½o fresco.', en: 'Crispy pastel stuffed with fresh shrimp.', es: 'Pastel crujiente relleno de camarï¿½n fresco.' },
    price: 15.00,
    image: FOOD_IMAGES.PASTEL_CAMARAO,
    category: 'Pastï¿½is',
    available: true,
    popular: true
  },
  {
    id: 'prod_maria_02',
    vendorId: 'vendor_r5_01',
    name: { pt: 'Pastel de Carne', en: 'Meat Pastel', es: 'Pastel de Carne' },
    description: { pt: 'Clï¿½ssico pastel de feira com carne moï¿½da temperada.', en: 'Classic street pastel with seasoned ground beef.', es: 'Pastel clï¿½sico de feria con carne molida sazonada.' },
    price: 10.00,
    image: 'https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?auto=format&fit=crop&q=80&w=400',
    category: 'Pastï¿½is',
    available: true
  }
];

export const INITIAL_DRIVERS: Driver[] = [
  {
    id: 'driver_jeferson_01',
    name: 'Jeferson - Motoboy',
    email: 'jeferson@gmail.com',
    phone: '85999999999',
    cpf: '00011122233',
    cnh: 'CE00000001',
    vehicleType: 'motorcycle',
    vehicle: 'Honda Bros 160',
    plate: 'JEF-0001',
    isOnline: true,
    status: 'available',
    userStatus: 'active',
    earnings: 0,
    totalDeliveries: 0,
    rating: 5.0
  },
  {
    id: 'driver_moto_01',
    name: 'Carlos Delivery',
    email: 'moto1@test.com',
    phone: '85966001001',
    cpf: '11122233344',
    cnh: 'CE12345678',
    vehicleType: 'motorcycle',
    vehicle: 'Honda CG 160',
    plate: 'ABC-1234',
    isOnline: true,
    status: 'available',
    userStatus: 'active',
    earnings: 0,
    totalDeliveries: 0,
    rating: 5.0
  },
  {
    id: 'driver_moto_02',
    name: 'Rafael Entregas',
    email: 'moto2@test.com',
    phone: '85966002002',
    cpf: '55566677788',
    cnh: 'CE87654321',
    vehicleType: 'motorcycle',
    vehicle: 'Yamaha Fazer 250',
    plate: 'XYZ-5678',
    isOnline: true,
    status: 'available',
    userStatus: 'active',
    earnings: 0,
    totalDeliveries: 0,
    rating: 4.8
  },
  {
    id: 'driver_car_01',
    name: 'Marcos Entregas',
    email: 'carro@test.com',
    phone: '85966003003',
    cpf: '99988877766',
    cnh: 'CE11223344',
    vehicleType: 'car',
    vehicle: 'Fiat Uno',
    plate: 'DEF-9012',
    isOnline: false,
    status: 'offline',
    userStatus: 'active',
    earnings: 0,
    totalDeliveries: 0,
    rating: 4.9
  }
];

export const TRANSLATIONS = {
  pt: {
    searchPlaceholder: "O que vocï¿½ deseja na orla?",
    addToOrder: "Adicionar",
    yourCooler: "Sua Cesta",
    emptyCooler: "Cesta vazia!",
    emptyCoolerSub: "Explore as barracas da orla.",
    total: "Total",
    checkout: "Finalizar Pedido",
    assistantGreeting: "Olï¿½! Sou o Manu, concierge do E-Ambulante. Como posso tornar seu dia na orla incrï¿½vel?",
    assistantButton: "Manu AI",
    popular: "DESTAQUE"
  }
};

export const MANUALS = {
  CLIENT: {
    title: "Como pedir seu lanche na orla",
    steps: [
      "1. Escolha uma barraca verificada no mapa ou lista.",
      "2. Adicione os itens desejados ï¿½ sua cesta.",
      "3. Informe sua localizaï¿½ï¿½o e finalize o pedido.",
      "4. Aguarde a entrega no seu local!"
    ]
  }
};

export const HERO_IMAGES = {
  APP_BANNER: BRAND_ASSETS.HERO_BANNER,
  DEFAULT_VENDOR_BANNER: BRAND_ASSETS.DEFAULT_VENDOR_BANNER
};

// ============================================
// ðŸ’° CONFIGURAÃ‡ÃƒO FINANCEIRA CENTRALIZADA
// FONTE ÃšNICA DE VERDADE â€” NÃƒO duplicar em componentes
// ============================================
export const PLATFORM_CONFIG = {
  /** ComissÃ£o varejo (10%) */
  COMMISSION_RATE_RETAIL: 0.10,
  /** ComissÃ£o atacado (5%) */
  COMMISSION_RATE_WHOLESALE: 0.05,
  /** Assinatura mensal padrÃ£o do vendedor */
  DEFAULT_VENDOR_FEE: 29.90,
  /** Firestore collection para settings dinÃ¢micos */
  SETTINGS_COLLECTION: 'platformSettings',
  /** Doc ID para configuraÃ§Ãµes globais */
  SETTINGS_DOC_ID: 'global',
} as const;

export const ORDER_STATUS_LABELS: Record<string, string> = {
  pending: 'Pendente',
  confirmed: 'Confirmado',
  preparing: 'Preparando',
  ready: 'Pronto',
  ready_for_pickup: 'Pronto p/ Coleta',
  delivering: 'Em Entrega',
  delivered: 'Entregue',
  completed: 'ConcluÃ­do',
  cancelled: 'Cancelado',
  archived: 'Arquivado',
};

export const ORDER_FINAL_STATUSES = ['completed', 'delivered', 'cancelled', 'archived'] as const;
export const ORDER_ACTIVE_STATUSES = ['pending', 'confirmed', 'preparing', 'ready', 'ready_for_pickup', 'delivering'] as const;

